
import React, { useState } from 'react';
import { Button } from "@/components/ui/button";
import { PlusIcon } from "lucide-react";
import { AddUserDialog } from './AddUserDialog';

interface AddUserButtonProps {
  onUserAdded?: () => void;  // Add callback prop
}

export const AddUserButton = ({ onUserAdded }: AddUserButtonProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  return (
    <>
      <Button onClick={handleOpenDialog}>
        <PlusIcon className="mr-2 h-4 w-4" />
        Add User
      </Button>
      
      <AddUserDialog 
        isOpen={isDialogOpen} 
        onClose={handleCloseDialog}
        onUserAdded={onUserAdded}  // Pass the callback
      />
    </>
  );
};
